import { getCanvasCoord } from '../../utils/utils.js'

export const handleBlockEraserMove = (state) => {
  const {
    clientCoord,
    translate,
    scope,
    paths,
    erasedPathKeys,
    blockEraserScaledHalfSizeRef,
    setBlockEraserPosition,
  } = state

  const eraserPositionX = getCanvasCoord(clientCoord, translate, scope).x
  const eraserPositionY = getCanvasCoord(clientCoord, translate, scope).y

  // blockEraserScaledHalfSizeRef.current = {
  //   width: Math.floor((e.width * scaleRatio.current) / scope / 4),
  //   height: Math.floor((e.height * scaleRatio.current) / scope / 4),
  // }
  setBlockEraserPosition({
    top: eraserPositionY - blockEraserScaledHalfSizeRef.current.height,
    left: eraserPositionX - blockEraserScaledHalfSizeRef.current.width,
  })

  // --- 드래그 박스에 포함된 path를 선별 ---
  for (let pathKey of Object.keys(paths)) {
    // isLocked: true; 이미지는 select 불가
    if (paths[pathKey].isLocked === true) continue
    // eraserPathKeys.include: 이미 삭제 대상인 paths는 검사 X
    if (erasedPathKeys.current.includes(pathKey)) continue

    for (let point of paths[pathKey].points) {
      if (
        point.x + paths[pathKey].x >=
          eraserPositionX - blockEraserScaledHalfSizeRef.current.width &&
        point.x + paths[pathKey].x <=
          eraserPositionX + blockEraserScaledHalfSizeRef.current.width &&
        point.y + paths[pathKey].y >=
          eraserPositionY - blockEraserScaledHalfSizeRef.current.height &&
        point.y + paths[pathKey].y <= eraserPositionY + blockEraserScaledHalfSizeRef.current.height
      ) {
        erasedPathKeys.current.push(pathKey)
        document.getElementById(`sg-shape-${pathKey}`).style.opacity *= 0.25
        break
      }
    }
  }
}
